/* eslint-disable camelcase */

export enum CasinoTypes {
    social = 'social',
    normal = 'normal',
}
